import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  FormCheck,
  Modal,
  ModalBody,
  ModalHeader,
  ModalTitle,
} from "react-bootstrap";
import FormCheckInput from "react-bootstrap/esm/FormCheckInput";
import { toast } from "react-toastify";
import { toastOptions } from "../lib/toastOptions";
import {
  collection,
  doc,
  getDoc,
  getDocs,
  updateDoc,
} from "firebase/firestore";
import { db } from "../FirebaseConfig";
import { UserAuth } from "../Context";
import ProfilePicture from "../UserProfile/ProfilePicture";
import { Eye } from "react-bootstrap-icons";
import { Link } from "react-router-dom";
const PrivacySetting = () => {
  const { user } = UserAuth();
  const [checkBox, setCheckBox] = useState({
    friendRequest: true,
    message: true,
    profilePicture: true,
    birthday: true,
    location: true,
  });
  const [blockedUsers, setBlockedUsers] = useState([
    {
      id: "asad",
      userName: "Asad M.Furqan",
    },
    {
      id: "fahad",
      userName: "Fahad Ausaf",
    },
    {
      id: "osama",
      userName: "Osama A.Siddique",
    },
    {
      id: "sami",
      userName: "Abdul Sami",
    },
  ]);
  const [showModal, setShowModal] = useState(false);
  const fetchCheckBoxData = async () => {
    const userRef = doc(db, "users", user?.uid);
    const userSnap = await getDoc(userRef);
    if (userSnap.exists()) {
      const data = userSnap.data()?.privacySetting || {
        friendRequest: true,
        message: true,
        profilePicture: true,
        birthday: true,
        location: true,
      };
      setCheckBox(data);
    }
  };
  const fetchBlockedUsersData = async () => {
    const userRef = collection(db, "users", user?.uid, "blockedUsers");
    const userSnap = await getDocs(userRef);
    if (userSnap.size > 0) {
    }
  };
  const handleClose = () => setShowModal(false);
  useEffect(() => {
    fetchCheckBoxData();
  }, [user]);

  const handleSubmit = async () => {
    const userRef = doc(db, "users", user?.uid);
    await updateDoc(userRef, { privacySetting: { ...checkBox } });
    toast.success("Changes saved successfully!", toastOptions);
  };
  const handleUnblock = (index) => {
    toast.success(`Unblocked ${blockedUsers[index].userName}`, toastOptions);
    const tempBlockUsers = blockedUsers.filter(
      (user) => user.id != blockedUsers[index].id
    );
    setBlockedUsers(tempBlockUsers);
  };
  return (
    <>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}
      >
        <style jsx>
          {`
            .privacyOption {
              padding-top: 16px;
              padding-right: 12px;
              padding-bottom: 16px;
              padding-left: 12px;
              gap: 16px;
              box-shadow: 0px 0px 8px 0px #0000001f;
              border-radius: 8px;
            }

            .privacyOptionLabel {
              font-family: Inter;
              font-weight: 500;
              font-style: Medium;
              font-size: 18px;
              color: #000000;
            }

            .privacyOptionText {
              font-family: Inter;
              font-weight: 400;
              font-style: Regular;
              font-size: 14px;
              color: #676a79;
            }
          `}
        </style>
        <div
          className="d-flex flex-column pb-3 pt-0 pt-md-3"
          style={{ gap: "12px" }}
        >
          <div className="privacyOption d-flex justify-content-between align-items-center">
            <div style={{ cursor: "pointer" }}>
              <label
                style={{ cursor: "pointer" }}
                className="mb-0 privacyOptionLabel"
                htmlFor="friendRequestCheckbox"
              >
                Friend Request
              </label>
              <div className="privacyOptionText">
                Allow anyone to send you friend request
              </div>
            </div>
            <FormCheck className="form-switch">
              <FormCheckInput
                style={{ width: "36px", height: "22.5px" }}
                id="friendRequestCheckbox"
                type="checkbox"
                role="switch"
                checked={checkBox.friendRequest}
                onChange={() =>
                  setCheckBox((prev) => ({
                    ...prev,
                    friendRequest: !prev.friendRequest,
                  }))
                }
              />
            </FormCheck>
          </div>
          <div className="privacyOption d-flex justify-content-between align-items-center">
            <div style={{ cursor: "pointer" }}>
              <label
                style={{ cursor: "pointer" }}
                className="mb-0 privacyOptionLabel"
                htmlFor="messageCheckbox"
              >
                Message
              </label>
              <div className="privacyOptionText">
                Allow anyone to send you send message
              </div>
            </div>
            <FormCheck className="form-switch">
              <FormCheckInput
                style={{ width: "36px", height: "22.5px" }}
                id="messageCheckbox"
                type="checkbox"
                role="switch"
                checked={checkBox.message}
                onChange={() =>
                  setCheckBox((prev) => ({
                    ...prev,
                    message: !prev.message,
                  }))
                }
              />
            </FormCheck>
          </div>
          <div className="privacyOption d-flex justify-content-between align-items-center">
            <div style={{ cursor: "pointer" }}>
              <label
                style={{ cursor: "pointer" }}
                className="mb-0 privacyOptionLabel"
                htmlFor="pfpCheckBox"
              >
                Profile picture
              </label>
              <div className="privacyOptionText">
                Allow anyone to see your profile picture
              </div>
            </div>
            <FormCheck className="form-switch">
              <FormCheckInput
                style={{ width: "36px", height: "22.5px" }}
                id="pfpCheckBox"
                type="checkbox"
                role="switch"
                checked={checkBox.profilePicture}
                onChange={() =>
                  setCheckBox((prev) => ({
                    ...prev,
                    profilePicture: !prev.profilePicture,
                  }))
                }
              />
            </FormCheck>
          </div>
          <div className="privacyOption d-flex justify-content-between align-items-center">
            <div style={{ cursor: "pointer" }}>
              <label
                style={{ cursor: "pointer" }}
                className="mb-0 privacyOptionLabel"
                htmlFor="birthdayCheckBox"
              >
                Birthday
              </label>
              <div className="privacyOptionText">
                Allow anyone to see your birthday
              </div>
            </div>
            <FormCheck className="form-switch">
              <FormCheckInput
                style={{ width: "36px", height: "22.5px" }}
                id="birthdayCheckBox"
                type="checkbox"
                role="switch"
                checked={checkBox.birthday}
                onChange={() =>
                  setCheckBox((prev) => ({
                    ...prev,
                    birthday: !prev.birthday,
                  }))
                }
              />
            </FormCheck>
          </div>
          <div className="privacyOption d-flex justify-content-between align-items-center">
            <div style={{ cursor: "pointer" }}>
              <label
                style={{ cursor: "pointer" }}
                className="mb-0 privacyOptionLabel"
                htmlFor="locationCheckBox"
              >
                Location
              </label>
              <div className="privacyOptionText">
                Allow anyone to see your location
              </div>
            </div>
            <FormCheck className="form-switch">
              <FormCheckInput
                style={{ width: "36px", height: "22.5px" }}
                id="locationCheckBox"
                type="checkbox"
                role="switch"
                checked={checkBox.location}
                onChange={() =>
                  setCheckBox((prev) => ({
                    ...prev,
                    location: !prev.location,
                  }))
                }
              />
            </FormCheck>
          </div>
          {/* <div className="privacyOption d-flex justify-content-between align-items-center">
            <div style={{ cursor: "pointer" }}>
              <div
                style={{ cursor: "pointer" }}
                className="mb-0 privacyOptionLabel"
              >
                Block users
              </div>
              <div className="privacyOptionText">
                See users you have blocked before
              </div>
            </div>
            <Button
              className="rounded-2 px-2 py-1"
              variant="primary"
              onClick={() => setShowModal(true)}
            >
              <Eye className="fs-6 me-1" />
              <span>View</span>
            </Button>
          </div> */}
        </div>
        <div className="d-md-none px-0">
          <button type="submit" className="btn btn-primary mb-0 w-100">
            Save changes
          </button>
        </div>
        <div className="d-none d-md-block ms-auto text-end px-0">
          <button type="submit" className="btn btn-primary mb-0">
            Save changes
          </button>
        </div>
      </form>

      <Modal show={showModal} centered onHide={handleClose}>
        <ModalHeader closeButton className="pb-1">
          <ModalTitle>
            <div className="h5 fw-semibold">Blocked Users</div>
          </ModalTitle>
        </ModalHeader>
        <ModalBody className="py-0">
          {blockedUsers.map((user, index) => {
            return (
              <div className="my-3 d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                  <div className="avatar">
                    <ProfilePicture userData={user} />
                  </div>
                  <div className="mx-2">
                    <h6 className="mb-0">{user.userName}</h6>
                  </div>
                </div>
                <Button
                  variant="primary-soft"
                  size="sm"
                  onClick={() => handleUnblock(index)}
                >
                  Unblock
                </Button>
              </div>
            );
          })}
        </ModalBody>
      </Modal>
    </>
  );
};

export default PrivacySetting;
